import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox", "count", "submit"]

  connect() {
    this.update()
  }

  selectAll() {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = true })
    this.update()
  }

  selectOutOfOffice() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checkbox.dataset.category === "out_of_office"
    })
    this.update()
  }

  clear() {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = false })
    this.update()
  }

  update() {
    const count = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    this.countTarget.textContent = `${count} selected`
    this.submitTarget.disabled = count === 0
  }

  confirm(event) {
    const count = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    if (!window.confirm(`Move ${count} ${count === 1 ? "email" : "emails"} to Outlook Deleted Items? You can recover them from Outlook.`)) {
      event.preventDefault()
    }
  }
}
